import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Card, Dropdown, Menu, Popconfirm } from 'antd';
import { RootState } from '@store/index';
import { getManagers } from '@store/Actions/GetManagers';
import { deleteManager } from '@store/Actions/DeleteManager';
import { IManagers } from '@components/ManagerTable';
import NoResults from '@assets/icons/no-results.png';
import { MoreOutlined } from '@ant-design/icons';
import UpdateManager from '@components/UpdateManager';
import CardFilter from '@components/CardFilter';
import Cookies from 'js-cookie';

interface Props {
    loading: boolean;
    managers: IManagers[];
    deleteManager: (
        userId: number,
        email: string,
        name: string,
        lastName: string,
        photo: string,
        phoneNumber: string,
        franchiseId: number,
        isActive: number,
        companyId: number,
    ) => void;
    getManagers: () => void;
}

const ManagerCard: React.FC<Props> = ({
    loading,
    managers,
    deleteManager,
    getManagers,
}): JSX.Element => {
    const companyId = Cookies.get('companyId');
    const data: IManagers[] = [];

    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [rowData, setRowData] = useState<any>('');
    const [query, setQuery] = useState<string>('');
    const [search, setSearch] = useState<any>([]);

    useEffect(() => {
        getManagers();
    }, []);

    const searchFilter = (search) => {
        setQuery(search);

        const searchResult = data.filter(
            (query: IManagers) =>
                query.nameComplete
                    .toLowerCase()
                    .includes(search.toLowerCase()) ||
                query.email.toLowerCase().includes(search.toLowerCase()) ||
                query.franchise.toLowerCase().includes(search.toLowerCase()) ||
                query.phoneNumber.includes(search),
        );

        if (search.length > 0) {
            setSearch(searchResult);
        } else {
            setSearch(data);
        }
    };

    managers.map((manager: IManagers) => {
        if (manager.isActive === 1) {
            data.push({
                ...manager,
                nameComplete: `${manager.name} ${manager.lastName}`,
            });
        }
    });

    console.log(data, 'data');

    const closeModal = () => {
        setModalVisible(false);
    };

    const handleUpdate = (manager) => {
        setModalVisible(true);
        setRowData(manager);
    };

    const handleDelete = async (manager: IManagers) => {
        await deleteManager(
            manager.userId,
            manager.email,
            manager.name,
            manager.lastName,
            'uri', //photo
            manager.phoneNumber,
            manager.franchiseId,
            0, //isActive
            parseInt(companyId ?? ''),
        );
        getManagers();
    };

    const menu = (manager: IManagers) => (
        <Menu onClick={() => {}} key={manager.userId}>
            <Menu.Item key="0">
                <a onClick={() => handleUpdate(manager)}>Editar</a>
            </Menu.Item>
            <Menu.Item key="1">
                <Popconfirm
                    title="¿Eliminar usuario?"
                    onConfirm={() => handleDelete(manager)}
                    okText="Yes"
                    cancelText="No"
                >
                    <a onClick={() => {}}>Eliminar</a>
                </Popconfirm>
            </Menu.Item>
        </Menu>
    );

    return (
        <div>
            {loading ? (
                <>
                    <Card loading={loading} style={{ marginBottom: '1.5em' }} />
                    <Card loading={loading} style={{ marginBottom: '1.5em' }} />
                    <Card loading={loading} />
                </>
            ) : (
                <>
                    <div
                        style={{
                            marginBottom: '1em',
                        }}
                    >
                        <CardFilter
                            query={query}
                            changeQuery={searchFilter}
                            placeholder="Filtrar por nombre, sucursal, telefono y correeo"
                        />
                    </div>
                    {search.length !== 0 ? (
                        search.map((manager: IManagers, index: number) => (
                            <Card
                                style={{ marginBottom: '1.5em' }}
                                key={`${manager.userId}-${index}`}
                                extra={
                                    <Dropdown
                                        overlay={() => menu(manager)}
                                        trigger={['click']}
                                    >
                                        <a onClick={(e) => e.preventDefault()}>
                                            <MoreOutlined />
                                        </a>
                                    </Dropdown>
                                }
                            >
                                <Card
                                    type="inner"
                                    title="Nombre"
                                    bordered={false}
                                >
                                    {manager.nameComplete}
                                </Card>
                                <Card
                                    type="inner"
                                    title="Correo"
                                    bordered={false}
                                >
                                    {manager.email}
                                </Card>
                                <Card
                                    type="inner"
                                    title="Telefono"
                                    bordered={false}
                                >
                                    {manager.phoneNumber}
                                </Card>

                                <Card
                                    type="inner"
                                    title="Locación"
                                    bordered={false}
                                >
                                    {manager.franchise}
                                </Card>
                            </Card>
                        ))
                    ) : (
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <img
                                src={NoResults}
                                style={{
                                    height: 200,
                                    width: 200,
                                    margin: '0 auto',
                                }}
                            />
                            <span style={{ color: 'grey' }}>
                                ¡Aun no hay supervisores!
                            </span>
                        </div>
                    )}
                </>
            )}
            <UpdateManager
                modalVisible={modalVisible}
                closeModal={closeModal}
                rowData={rowData}
            />
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        managers: state.GetManagers.managers,
        loading: state.GetManagers.loading,
    };
};

const mapDispatchToProps = {
    getManagers,
    deleteManager,
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagerCard);
